Application.Branding.Cover = {
    ui: {
        container: '.js-branding-cover',
        source: '.js-branding-cover__source',
        pulses: '.js-branding-cover__pulses',
        pulse: '.js-branding-cover__pulse',
        previewSource: '.js-branding-cover__preview-source',
        previewPulse: '.js-branding-cover__preview-pulse'
    },
    transformer: null,
    ready: function (transformer) {

        var self = this;

        if (!$(this.ui.container).length){
            return;
        }

        // save references
        this.transformer = transformer;

        // update preview position
        // bind on change
        $(this.ui.source).change(function(){
            self.update($(this).closest(self.ui.container));
            self.transformer.initSize();
        });
        $(this.ui.pulse).change(function(){
            self.update($(this).closest(self.ui.container));
        });
        // init
        $(this.ui.container).each(function(){
            self.update($(this));
        });

    },
    update: function($container){

        // find active options
        var $source = $container.find(this.ui.source).filter(':checked');
        var $pulse = $container.find(this.ui.pulse).filter(':checked');
        // apply to preview
        $(this.ui.previewSource).one('load', function(){
            $(this).addClass('ready');
        }).attr('src', $source.attr('data-source'));

        if ($source.attr('data-disabled-pulse') == '1'){
            $(this.ui.previewPulse).css({
                backgroundImage: ''
            }).addClass('ready');
            $(this.ui.pulses).addClass('disabled');
        }else{
            $(this.ui.previewPulse).css({
                backgroundImage: 'url("' + $pulse.attr('data-pulse') + '")'
            }).addClass('ready');
            $(this.ui.pulses).removeClass('disabled');
        }

    }
};